import {IFetchContext} from "@pg-mono/data-fetcher";

import {rpApi} from "../../app/api/rp_api";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {IRootState} from "../../store/store";
import {IAppDispatch} from "../../store/store";
import {isRtkqError} from "../../store/utils/is_rtkq_error";
import {getReelsList} from "../api/get_reels_list";

export const getReelListAction = (_ctx: IFetchContext<IRPRequestMeta, {}>) => async (dispatch: IAppDispatch, getState: () => IRootState) => {
    const regionIds = getState().offerList.selectedRegions.map((region: ISelectedRegion) => region.id);
    const reelList = await dispatch(getReelsList.endpoints.getReelsList.initiate({regionIds}));

    if ((reelList.isError && isRtkqError(reelList.error) && reelList.error.status === 404) || !reelList.data) {
        return true;
    }

    await Promise.all(dispatch(rpApi.util.getRunningQueriesThunk()));
};
import {IFetchContext} from "@pg-mono/data-fetcher";

import {rpApi} from "../../app/api/rp_api";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {IRootState} from "../../store/store";
import {IAppDispatch} from "../../store/store";
import {isRtkqError} from "../../store/utils/is_rtkq_error";
import {getReelsList} from "../api/get_reels_list";

export const getReelListAction = (_ctx: IFetchContext<IRPRequestMeta, {}>) => async (dispatch: IAppDispatch, getState: () => IRootState) => {
    const regionIds = getState().offerList.selectedRegions.map((region: ISelectedRegion) => region.id);
    const reelList = await dispatch(getReelsList.endpoints.getReelsList.initiate({regionIds}));

    if ((reelList.isError && isRtkqError(reelList.error) && reelList.error.status === 404) || !reelList.data) {
        return true;
    }

    await Promise.all(dispatch(rpApi.util.getRunningQueriesThunk()));
};
